export default __webpack_public_path__ + "static/media/Find a Provider.47f0dacf.svg";